import { OptionChoice, Question } from "../types";
import Dropdown from "./inputTypes/Dropdown";
import Slider from "./inputTypes/Slider";

export default function SurveyResponse(props: {
  optionChoices: Array<OptionChoice>;
  question: Question;
  selectedOptionId: number | undefined;
  setSelectedOption: (optionChoiceId: number) => void;
}) {
  return (
    <div>
      {/* Select Input Type */}
      {props.question.input_type_id === 1 && (
        <div className={`grid grid-cols-1 gap-3 lg:flex lg:justify-evenly lg:items-stretch basis-0 text-center`}>
          {props.optionChoices.map((optionChoice: OptionChoice) => (
            <button
              key={optionChoice.option_choice_id}
              className={`${
                props.selectedOptionId === optionChoice.option_choice_id
                  ? "bg-strata-blue text-white border-transparent"
                  : "bg-white border-gray-200 text-zinc-600 hover:bg-gray-50"
              }
                  items-center rounded-md border border-gray-300 px-6 py-3 text-base font-medium shadow-sm sm:mt-4 flex-grow basis-0`}
              onClick={() => {
                props.setSelectedOption(optionChoice.option_choice_id);
              }}
            >
              {optionChoice.option_choice_name}
            </button>
          ))}
        </div>
      )}

      {/* Slider Input */}
      {props.question.input_type_id === 2 && (
        <div>
          <Slider
            optionChoices={props.optionChoices}
            selectedOptionId={props.selectedOptionId}
            setSelectedOption={(optionChoice: OptionChoice) => {
              props.setSelectedOption(optionChoice.option_choice_id);
            }}
          />
        </div>
      )}

      {/* Dropdown Input */}
      {props.question.input_type_id === 3 && (
        <Dropdown
          selectedOptionId={1} //todo
          dropDownItems={props.optionChoices}
          setSelectedOption={(optionChoice: OptionChoice) => {
            props.setSelectedOption(optionChoice.option_choice_id);
          }}
        />
      )}
    </div>
  );
}
